import type React from "react";
import { useState } from "react";
import * as _ from "lodash";
import { AssetsService } from "app/services/AssetsService";
import { AutocompleteDigitalMarketing } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketing";
import { swSettings } from "app/common/services/swSettings";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import {
    PageContainer,
    TilesGroup,
    HeaderContentContainer,
    AutocompleteWrapper,
    PrimaryHomepageHeaderStyled,
    HeaderTitle,
    HeaderSubtitle,
    HomepageBodyTextStyled,
    TilesContainer,
    AcquisitionCustomDropdownContainer,
} from "./styledComponents";
import { MajorNavigationTile } from "./MajorNavigationTile";
import { navigationTiles as navigationTilesConfig } from "./constants";
import { ScrollContainer } from "app/components/layout/ScrollContainer";
import { AcquisitionCustomDropdown } from "app/pages/digital-suite/home-page/components/AcquisitionCustomDropdown";

const headerImageUrl = AssetsService.assetUrl("/images/secondary-home-page-header-light-small.png");

export const AcquisitionDefault: React.FC = () => {
    const [autocompleteOpen, setAutocompleteOpen] = useState<boolean>(false);
    const userFirstName = _.capitalize(swSettings.user.firstname);
    const userProductKey = swSettings.components.Home.resources.ProductKey;
    const [selectedSite, setSelectedSite] = useState<string>("");
    const onItemClick = (key: string) => {
        const isSingleSite = key.split(",").length === 1;
        if (isSingleSite) {
            setSelectedSite(key);
        }
    };

    const shouldNavigate = (key: string) => {
        return key.split(",").length > 1;
    };

    const tileFilter = (row) =>
        // if no userTypes were set
        row.userTypes == undefined ||
        // if user is not no touch
        userProductKey == null ||
        // if user is no touch and can view tile
        row.userTypes?.includes(userProductKey);

    const navigationTiles = navigationTilesConfig.filter(tileFilter);

    return (
        <ScrollContainer>
            <PageContainer className={"sw-layout-scrollable-element"}>
                {/* @ts-expect-error - bgColor is not defined on the type (should be optional in ui-components) */}
                <PrimaryHomepageHeaderStyled imageUrl={headerImageUrl}>
                    <HeaderContentContainer>
                        <div>
                            <HeaderTitle>
                                <I18n dataObj={{ name: userFirstName }}>{"acquisition.homepage.header.title"}</I18n>
                            </HeaderTitle>
                            <HeaderSubtitle>
                                <I18n>{"digitalsuite.acquisition.homepage.header.subtitle"}</I18n>
                            </HeaderSubtitle>
                        </div>
                        <AutocompleteWrapper>
                            {!selectedSite ? (
                                <AutocompleteDigitalMarketing
                                    includeKeywordsData
                                    maxCompareItemsToDisplay={1}
                                    onAutocompleteOpen={() => setAutocompleteOpen(true)}
                                    onAutocompleteClose={() => setAutocompleteOpen(false)}
                                    websiteState={"organicsearch_website_organic_search_overview"}
                                    onItemClick={onItemClick}
                                    shouldNavigate={shouldNavigate}
                                    RecentListSeparatorTextKey={
                                        "acquisition.home.page.autocomplete.list.item.separator"
                                    }
                                />
                            ) : (
                                <AcquisitionCustomDropdownContainer>
                                    <AcquisitionCustomDropdown
                                        domain={selectedSite}
                                        onClearClick={() => setSelectedSite("")}
                                    />
                                </AcquisitionCustomDropdownContainer>
                            )}
                        </AutocompleteWrapper>
                    </HeaderContentContainer>
                </PrimaryHomepageHeaderStyled>
                <TilesGroup>
                    <HomepageBodyTextStyled>
                        <I18n>{"digitalsuite.acquisition.homepage.tiles.title"}</I18n>
                    </HomepageBodyTextStyled>
                    <TilesContainer tilesPerRow={3}>
                        {navigationTiles.filter(tileFilter).map((tile) => (
                            <MajorNavigationTile
                                key={tile.title}
                                {...tile}
                            />
                        ))}
                    </TilesContainer>
                </TilesGroup>
            </PageContainer>
        </ScrollContainer>
    );
};
